import { publicApi } from "../api/api";

// POST /create-order-without-otp with retry on TRANSPORT failures.
// Why: on mobile + Facebook/Instagram in-app browsers the round-trip frequently stalls or
// drops even though the server creates the order in <1s — the user then sees a false
// "Order Creation" failure for an order that actually succeeded. The endpoint is idempotent
// (backend dedupes by lead_id / order_id → "order already exists for lead — reusing"), so a
// retry safely returns the already-created order instead of duplicating it.
// Only transport errors are retried (no HTTP response: timeout / Network Error); genuine
// 4xx/5xx responses have err.response and are surfaced immediately.
//
// Moved here from LandingPage.jsx (was lines 57-78) — already a clean, standalone,
// product-agnostic function with zero page-state dependency, so both LandingPage.jsx and
// NumerologyLandingPage.jsx import this same one instead of each having their own copy.
export async function postCreateOrderWithRetry(payload) {
  const MAX_ATTEMPTS = 3;
  let lastErr;
  for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
    try {
      // 30s vs the default 10s: server-side creation is sub-second, but flaky mobile /
      // in-app-browser networks need more headroom before we treat the call as failed.
      return await publicApi.post("/create-order-without-otp", payload, { timeout: 30000 });
    } catch (err) {
      lastErr = err;
      const isTransient =
        !err.response &&
        (err.code === "ECONNABORTED" ||
          err.message === "Network Error" ||
          (err.message && err.message.toLowerCase().includes("timeout")));
      if (!isTransient || attempt === MAX_ATTEMPTS) throw err;
      // brief linear backoff between attempts
      await new Promise((resolve) => setTimeout(resolve, 1500 * attempt));
    }
  }
  throw lastErr;
}
